const downloadModalBtns = document.querySelectorAll('#downloadModalTrigger');
if(downloadModalBtns != null){
  downloadModalBtns.forEach((downloadModalBtn) => {
    downloadModalBtn.addEventListener('click', function(e) {
      let downloadModal = downloadModalBtn.querySelector("#downloadModal");
      let ModalLayer = downloadModalBtn.querySelector(".modal-layer");
      let ModalClose = downloadModal.querySelector("#downloadModal .modal__close button.js-modal-close .custom-icon-x");
      if (downloadModal) {
        // ポップアップの表示
        
        let contentTabBtns = downloadModal.querySelectorAll('.download-detail-tab-btn');
        let contents = downloadModal.querySelectorAll('.download-detail-content');
        if (!downloadModal.classList.contains('isOn')) {
          contentTabBtns.forEach((contentTabBtn, i) => {
            contentTabBtn.classList.remove('active')
            contents[i].classList.remove('active')
          });

          contentTabBtns[0].classList.add('active')
          contents[0].classList.add('active')
          e.stopPropagation();
        }

        downloadModal.classList.add("isOn");
        downloadModal.setAttribute("aria-modal", "true");
        ModalLayer.setAttribute("aria-hidden", "true");
        ModalClose.setAttribute("aria-hidden", "true");
      }

      ModalLayer.addEventListener('click', function(e){
        if (downloadModal.classList.contains("isOn")){
          downloadModal.classList.remove('isOn');
          downloadModal.setAttribute("aria-modal", "false");
          ModalLayer.setAttribute("aria-hidden", "false");
          ModalClose.setAttribute("aria-hidden", "false");
        }
        e.preventDefault();
        e.stopPropagation();
      });

      ModalClose.addEventListener('click', function(e){
        if (downloadModal.classList.contains("isOn")){
          downloadModal.classList.remove('isOn');
          downloadModal.setAttribute("aria-modal", "false");
          ModalLayer.setAttribute("aria-hidden", "false");
          ModalClose.setAttribute("aria-hidden", "false");
        }
        e.preventDefault();
        e.stopPropagation();
      });
    })
  })
}